import { createServerStateStore } from "./serverState";

export interface StockItem {
  id: string;
  tarih: string;
  kupeNo: string;
  siparisNo?: string;
  tur: "Büyükbaş" | "Küçükbaş" | "Karkas" | "Parçalanmış Ürün" | "Diğer";
  kategori?: string;
  tedarikci?: string;
  belgeNo?: string;
  kg?: number;
  kesimKg?: number;
  adet?: number;
  alisTutari?: number;
  nakliyeMaliyeti?: number;
  kesimMaliyeti?: number;
  parcalamaMaliyeti?: number;
  maliyetTutari?: number;
  satisGeliri?: number;
  not?: string;
  durum: "Stokta" | "Satışta" | "Rezerve" | "Kesildi" | "Parçalandı" | "Satıldı" | "Fire / Zayi" | "Pasif";
  createdAt: string;
  updatedAt: string;
}

function normalizeStockItem(value: unknown): StockItem {
  const item = (value ?? {}) as Partial<StockItem>;
  const now = new Date().toISOString();
  const allowedTur = ["Büyükbaş", "Küçükbaş", "Karkas", "Parçalanmış Ürün", "Diğer"];
  const tur = allowedTur.includes(String(item.tur)) ? (item.tur as StockItem["tur"]) : "Büyükbaş";
  const allowedDurum = ["Stokta", "Satışta", "Rezerve", "Kesildi", "Parçalandı", "Satıldı", "Fire / Zayi", "Pasif"];
  const durum = allowedDurum.includes(String(item.durum)) ? (item.durum as StockItem["durum"]) : "Stokta";
  return {
    id: String(item.id || crypto.randomUUID()),
    tarih: String(item.tarih || now.slice(0, 10)),
    kupeNo: String(item.kupeNo || "").trim(),
    siparisNo: item.siparisNo ? String(item.siparisNo).trim() : undefined,
    tur,
    kategori: item.kategori ? String(item.kategori).trim() : undefined,
    tedarikci: item.tedarikci ? String(item.tedarikci).trim() : undefined,
    belgeNo: item.belgeNo ? String(item.belgeNo).trim() : undefined,
    kg: item.kg === undefined ? undefined : Number(item.kg || 0),
    kesimKg: item.kesimKg === undefined ? undefined : Number(item.kesimKg || 0),
    adet: item.adet === undefined ? undefined : Number(item.adet || 1),
    alisTutari: item.alisTutari === undefined ? undefined : Number(item.alisTutari || 0),
    nakliyeMaliyeti: item.nakliyeMaliyeti === undefined ? undefined : Number(item.nakliyeMaliyeti || 0),
    kesimMaliyeti: item.kesimMaliyeti === undefined ? undefined : Number(item.kesimMaliyeti || 0),
    parcalamaMaliyeti: item.parcalamaMaliyeti === undefined ? undefined : Number(item.parcalamaMaliyeti || 0),
    maliyetTutari: item.maliyetTutari === undefined ? undefined : Number(item.maliyetTutari || 0),
    satisGeliri: item.satisGeliri === undefined ? undefined : Number(item.satisGeliri || 0),
    not: item.not ? String(item.not) : undefined,
    durum,
    createdAt: String(item.createdAt || now),
    updatedAt: String(item.updatedAt || now),
  };
}

function normalizeStock(value: unknown): StockItem[] {
  if (!Array.isArray(value)) return [];
  return value.map(normalizeStockItem).filter((item) => item.kupeNo);
}

const store = createServerStateStore<StockItem[]>("stock_items", [], normalizeStock);

export function getStockItems() {
  return store.getState();
}

export async function rehydrateStockItems() {
  return store.rehydrate();
}

export async function setAllStockItems(updater: StockItem[] | ((prev: StockItem[]) => StockItem[])) {
  return store.setState(updater);
}

export function subscribeStockItems(listener: () => void) {
  return store.subscribe(listener);
}
